<h1>{{ welcomeMessage | translate:{'name':name} }}</h1>
<obg-m-customer-verification-container
	[username]="username"
	[variant]="variant"
	(dismissDialog)="navigateToNextStep($event)"
>
</obg-m-customer-verification-container>
